import { GENERAL_SETTING_MENU } from "../../../constant/generalSetting";
import { GeneralSettingMenuType } from "../../../commonTypes/generalSettingType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./style.scss";
import { DropdownToggle } from "reactstrap";

type AppProp = {
  handleMenuNameChange: (name: string) => void;
  menuName: string;
};

const GeneralSettingSideMenu = ({
  handleMenuNameChange,
  menuName,
}: AppProp) => {
  return (
    <div className="p-3 side_menu">
      {GENERAL_SETTING_MENU?.map((item: GeneralSettingMenuType) => {
        return !item?.isDeveloped ? (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 250 }}
            overlay={
              <Tooltip id="button-view-download-invoice">Coming Soon</Tooltip>
            }
          >
            <div
              style={{ background: "#d9d9d9",cursor:"default" }}
              className={`single_menu`}
              key={item?.key}
            >
              {item?.name}
            </div>
          </OverlayTrigger>
        ) : (
          <div
            onClick={() => item?.isDeveloped && handleMenuNameChange(item.name)}
            className={`single_menu ${
              menuName === item?.name ? "selected_single_menu" : ""
            }`}
            key={item?.key}
          >
            {item?.name}
          </div>
        );
      })}
    </div>
  );
};

export default GeneralSettingSideMenu;
